var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 12-3.398 1.786a.727.727 0 0 1-1.055-.766l.649-3.784-2.75-2.68a.727.727 0 0 1 .404-1.24l3.799-.552L7.348 1.32a.727.727 0 0 1 1.304 0l1.7 3.443 3.798.552c.597.087.835.82.403 1.24l-2.749 2.68.65 3.784a.727.727 0 0 1-1.056.766L8 12z"
  })));
};

export default SvgStar;